import { createStore } from 'vuex';
import auth from './modules/auth'; // Importando o módulo de autenticação
import taskData from './modules/taskData';

const store = createStore({
  modules: {
    auth,
    taskData
  }
});

export default store;
